import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { setLanguage } from 'redux-i18n'

const LanguageSelector = ({ lang, setLanguage }) => {
	const handleChange = e => {
		const selectedLang = e.target.value
		setLanguage(selectedLang)
	}

	return (
		<select
			value={lang}
			onChange={handleChange}
			style={{
				padding: '5px',
				fontSize: '14px',
				borderRadius: '4px',
				border: '1px solid gray',
				cursor: 'pointer',
				marginTop: '10px'
			}}
		>
			<option value="en">English</option>
			<option value="hi">Hindi</option>
			<option value="gu">Gujarati</option>
		</select>
	)
}

LanguageSelector.propTypes = {
	lang: PropTypes.string.isRequired,
	setLanguage: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
	lang: state.i18nState.lang
})

export default connect(mapStateToProps, { setLanguage })(LanguageSelector)
